module.exports = __webpack_public_path__ + "static/media/notification-fill.0ef9b608.svg";